module.exports = __webpack_public_path__ + "img/Fragaria_vesca.4b77354d.jpg";